module.exports = __webpack_public_path__ + "static/media/proximanova-semibold.d1d5b563.ttf";